import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
export const useAdHocInvoice = (invoiceId)=>{
    const { api } = useStoreActions();
    const { data, isLoading, refresh } = useQueryState({
        queryKey: [
            QueryKeys.Invoice,
            invoiceId
        ],
        queryFn: ()=>api.invoice.getByID(invoiceId, true),
        enabled: !!invoiceId
    });
    return {
        invoice: data,
        isLoading,
        refresh
    };
};
